import { common } from './common';

export const zhCN = {
  common,
};